var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainView",attrs:{"id":"tableauView"}},[_vm._v("TODO")])
}
var staticRenderFns = []

export { render, staticRenderFns }